import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlToPlaintext',
    standalone: false
})
export class HtmlToPlaintextPipe implements PipeTransform {
    transform(value: any): string {
        var strippedHtml = value.replace(/<[^>]+>/g, '  ');
        return strippedHtml || '';
    }
}